import apiClient from 'api/apiClient';
import { City } from 'model/City';

export const getAllCities = async (): Promise<City[]> => {
  const response = await apiClient.get('/v1/cities');
  return response?.data;
};
